var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0135 29.9943C17.006 30.0019 16.9938 30.0019 16.9862 29.9943L4.00568 16.8434C3.99354 16.8311 4.00214 16.8101 4.0193 16.8101H9.5078C10.1288 16.8101 10.6323 16.2997 10.6323 15.6708V2.01951C10.6323 2.00874 10.6409 2 10.6516 2H23.3484C23.3591 2 23.3677 2.00874 23.3677 2.01951V15.6708C23.3677 16.2997 23.8712 16.8101 24.4922 16.8101H29.9807C29.9979 16.8101 30.0065 16.8311 29.9943 16.8434L17.0135 29.9943ZM25.7092 14.7975C25.6985 14.7975 25.6898 14.7887 25.6898 14.778V1.13829C25.6898 0.509649 25.182 0 24.5564 0H9.44561C8.81993 0 8.31218 0.509649 8.31218 1.13829V14.778C8.31218 14.7887 8.30349 14.7975 8.29277 14.7975L1.13447 14.7977C0.138728 14.7977 -0.385242 16.0186 0.333492 16.7404L16.1861 32.661C16.6362 33.113 17.3658 33.113 17.8158 32.661L33.6493 16.7597C34.3796 16.0599 33.8971 14.7975 32.8675 14.7975H25.7092Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.bbe505e864922cf87219635a117fcddf.svg";
export { ForwardRef as ReactComponent };